import { Action, Status } from 'types';

export interface StatusReducer {
  globalSettingsStatus: Status;
  postArticleRatingStatus: Status;
  postArticleUserStoryStatus: Status;
  submitBusinessOnboardingFormStatus: Status;
  submitGeneralInquiryStatus: Status;
}

const initialState: StatusReducer = {
  globalSettingsStatus: Status.IDLE,
  postArticleRatingStatus: Status.IDLE,
  postArticleUserStoryStatus: Status.IDLE,
  submitBusinessOnboardingFormStatus: Status.IDLE,
  submitGeneralInquiryStatus: Status.IDLE,
};

export default (
  state: StatusReducer = initialState,
  action: Action
): StatusReducer => {
  switch (action.type) {
    case 'FETCH_GLOBAL_SETTINGS_PENDING':
      return { ...state, globalSettingsStatus: Status.PENDING };
    case 'FETCH_GLOBAL_SETTINGS_FULFILLED':
      return { ...state, globalSettingsStatus: Status.FULFILLED };
    case 'FETCH_GLOBAL_SETTINGS_REJECTED':
      return { ...state, globalSettingsStatus: Status.REJECTED };

    case 'POST_ARTICLE_RATING_PENDING':
      return { ...state, postArticleRatingStatus: Status.PENDING };
    case 'POST_ARTICLE_RATING_FULFILLED':
      return { ...state, postArticleRatingStatus: Status.FULFILLED };
    case 'POST_ARTICLE_RATING_REJECTED':
      return { ...state, postArticleRatingStatus: Status.REJECTED };

    case 'POST_ARTICLE_USER_STORY_PENDING':
      return { ...state, postArticleUserStoryStatus: Status.PENDING };
    case 'POST_ARTICLE_USER_STORY_FULFILLED':
      return { ...state, postArticleUserStoryStatus: Status.FULFILLED };
    case 'POST_ARTICLE_USER_STORY_REJECTED':
      return { ...state, postArticleUserStoryStatus: Status.REJECTED };

    case 'SUBMIT_BUSINESS_ONBOARDING_FORM_PENDING':
      return {
        ...state,
        submitBusinessOnboardingFormStatus: Status.PENDING,
      };
    case 'SUBMIT_BUSINESS_ONBOARDING_FORM_FULFILLED':
      return {
        ...state,
        submitBusinessOnboardingFormStatus: Status.FULFILLED,
      };
    case 'SUBMIT_BUSINESS_ONBOARDING_FORM_REJECTED':
      return {
        ...state,
        submitBusinessOnboardingFormStatus: Status.REJECTED,
      };

    case 'SUBMIT_GENERAL_INQUIRY_PENDING':
      return {
        ...state,
        submitGeneralInquiryStatus: Status.PENDING,
      };
    case 'SUBMIT_GENERAL_INQUIRY_FULFILLED':
      return {
        ...state,
        submitGeneralInquiryStatus: Status.FULFILLED,
      };
    case 'SUBMIT_GENERAL_INQUIRY_REJECTED':
      return {
        ...state,
        submitGeneralInquiryStatus: Status.REJECTED,
      };

    default:
      return state;
  }
};
